<template>
  <div class="animated fadeIn" v-if="!loading">
    <basic-heading title="Order Details">
      <template #right-content>
        <b-button-toolbar key-nav aria-label="Key Order Actions">
          <b-button variant="success" class="ml-1 text-white" to="/orders"
            ><i class="fal fa-list"></i
          ></b-button>
        </b-button-toolbar>
      </template>
    </basic-heading>
    <div class="invoice-box">
      <table cellpadding="0" cellspacing="0">
        <tr class="top">
          <td colspan="4">
            <table>
              <tr>
                <td class="title">
                  <img
                    src="img/brand/logo.png"
                    style="width: 100%; max-width: 230px"
                  />
                </td>

                <td>
                  <!--                 (this.customer ? this.customer.account_number : 'TBD') }}-{{1 -->
                  Invoice #:
                  {{
                    this.invoice
                      ? this.invoice.stripe_id || this.invoice.id
                      : "N/A"
                  }}
                  <br />
                  Created: {{ this.invoice ? this.invoice.created_at : "" }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr class="information">
          <td colspan="4">
            <table>
              <tr>
                <td>
                  Down to Earth Labs<br />
                  3510 6th Avenue North<br />
                  Lethbridge, AB T1H 5C3
                </td>

                <td>
                  {{ this.customer ? this.customer.full_name : null }}<br />{{
                    this.customer
                      ? this.customer.customer_locations[0].street_address
                      : null
                  }}
                  <br />
                  {{
                    this.customer
                      ? this.customer.customer_locations[0].city +
                        ", " +
                        this.customer.customer_locations[0].region +
                        " " +
                        this.customer.customer_locations[0].postal_code
                      : null
                  }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr class="heading">
          <td colspan="6">Payment Method</td>
        </tr>

        <tr class="details">
          <td colspan="6">{{ paymentMethod() }}</td>
        </tr>

        <tr class="heading">
          <td>Item</td>
          <td>Unit Cost</td>
          <td>Quantity</td>
          <td>Price</td>
        </tr>

        <tr class="item" v-for="(item, index) in items" :key="index">
          <td>
            <span>{{ item.description }}</span>
          </td>
          <td>
            $<span>{{ item.price }}</span>
          </td>
          <td>
            <span>{{ item.quantity }}</span>
          </td>
          <td>${{ (item.price * item.quantity) | currency }}</td>
        </tr>

        <br />

        <tr class="total">
          <td colspan="3"></td>
          <td>Total: ${{ total | currency }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import InvoiceModel from "../../../models/cashier/InvoiceModel";
import CustomerModel from "../../../models/crm/CustomerModel";

export default {
  components: {
    BasicHeading,
  },
  name: "OrderDetail",
  data() {
    return {
      loading: true,
      id: this.$route.params.id || null,
      invoice: null,
      invoice_items: null,
      customer: null,
      items: [],
    };
  },
  computed: {
    total() {
      return this.items.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
  },
  filters: {
    currency(value) {
      return value.toFixed(2);
    },
  },
  methods: {
    fetchInvoice() {
      this.loading = true;
      if (this.id) {
        const id = this.id;
        let invoice = new InvoiceModel({ id });
        invoice.fetch().then(() => {
          this.invoice = invoice;
          this.invoice_items = invoice.getInvoiceItems();
          if (this.invoice_items && this.invoice_items.length) {
            this.invoice_items.each((item) => {
              let price = null;
              let quantity = null;
              if (item.quantity) {
                quantity = +item.quantity;
                price = +item.unit_amount / 100;
              } else {
                quantity = 1;
                price = +item.amount / 100;
              }
              this.items.push({
                description: item.description,
                quantity: quantity,
                price: price,
              });
            });
          }
          let customer = invoice.getCustomer();
          if (customer && customer.id) {
            let crm_customer = new CustomerModel({ id: customer.id });
            crm_customer.fetch().then(() => {
              this.customer = crm_customer;
              this.loading = false;
            });
          } else {
            this.loading = false;
          }
        });
        // InvoicesRepository.get(id).then((response) => {
        //   if (response && response.status === 200 && response.data) {
        //
        //     this.items = [];
        //     this.invoice = response.data;
        //     this.invoice_items = this.invoice.invoice_items;
        //     if(this.invoice_items && this.invoice_items.length) {
        //       this.invoice_items.forEach((item) => {
        //         let price = null
        //         let quantity = null;
        //         if(item.quantity) {
        //           quantity = +(item.quantity);
        //           price = (+(item.unit_amount) / 100);
        //         } else {
        //           quantity = 1;
        //           price = (+(item.amount) / 100);
        //         }
        //         this.items.push({ description: item.description, quantity: quantity, price: price });
        //       });
        //     }
        //     let user_id = this.invoice.customer_id;
        //     CustomerRepository.getFromUser(user_id).then((cust_response) => {
        //       if(cust_response.data && cust_response.data.id) {
        //         this.customer = cust_response.data;
        //       }
        //     });
        //   }
        // });
      }
    },
    paymentMethod() {
      return this.invoice.stripe_id
        ? "Credit Card"
        : "Credit Account (Requires Payment)";
    },
  },
  mounted() {
    this.fetchInvoice();
  },
};
</script>
<style>
.invoice-box {
  margin: auto;
  margin-top: 2rem;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(n + 2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.item input {
  padding-left: 5px;
}

.invoice-box table tr.item td:first-child input {
  margin-left: -5px;
  width: 100%;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box input[type="number"] {
  width: 60px;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

/** RTL **/
.rtl {
  direction: rtl;
  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
    sans-serif;
}

.rtl table {
  text-align: right;
}

.rtl table tr td:nth-child(2) {
  text-align: left;
}
</style>
